<!-- <template>
  <div>
    <div class="container-fluid overflow-hidden">
      <div class="row vh-100 remove-vh-100-sm2  overflow-auto">
        <AppSidebar />

        <main class="col d-flex flex-column h-sm-100">
          <Navbar />
          <router-view></router-view>
        </main>
      </div>
    </div>
  </div>
</template> -->
<template>
  <div>
    <!-- Use the new mainNavbar component -->
    <mainNavbar />
    <!-- Usar flexbox para el layout principal -->
    <div class="container-fluid overflow-hidden">
      <div class="row vh-100 flex-nowrap">
        <!-- Sidebar envuelto en un div para control CSS -->
          <AppSidebar class="sidebar-container" />

        <!-- Contenido principal ocupa el resto y permite scroll vertical -->
        <main class="col d-flex flex-column h-100 overflow-auto">
          <Navbar class="adMArings" />
          <!-- Asegurar que router-view crezca para llenar el espacio -->
          <div class="flex-grow-1">
            <router-view></router-view>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
  import Navbar from '@/components/Navbar.vue';
  import mainNavbar from '@/components/mainNavbar.vue';
  import AppSidebar from '@/components/Footer.vue';
  import axios from 'axios';
  var config = require("@/config/api.json");
  const API = config.api;
  import { auth } from "@/fb";

  export default {
    name: 'Dashboard',
    components: {
      Navbar, mainNavbar, AppSidebar
    },
    data() {
      return {
        storedUser: null,
      };
    },
    async created() {
      try {
        // localStorage.removeItem('user');
        await this.checkAuthState();
        const user = auth.currentUser;
        if (user) {
          this.storedUser = JSON.parse(localStorage.getItem('user'));
        }
      } catch (error) {
        console.error("Error en mounted: ", error);
      }


    },
  }
</script>
<style scoped>
/* Optional: Hide the main Navbar component on small screens if needed */
/* @media (max-width: 575.98px) {
  main > Navbar {
    display: none;
  }
} */


@media (max-width: 876px) {
  .sidebar-container {
    display: none;
  }
  .adMArings {
    margin-top: 5rem; /* Adjusted margin for Navbar on small screens */
  }
}
</style>